import { render, staticRenderFns } from "./FeedbackNegativeView.vue?vue&type=template&id=c3f974b0"
import script from "./FeedbackNegativeView.vue?vue&type=script&lang=ts"
export * from "./FeedbackNegativeView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports